import { CopyButton } from '@/components/CopyButton/CopyButton';
import { Flex } from '@mantine/core';
import { Upload } from 'react-feather';
import classes from './ItemHeading.module.css';

interface ItemHeadingProps {
  name: string;
  id?: string;
  displayName?: string;
  url?: string;
  copyNameEvent?: string;
  copyURLEvent?: string;
  closeButton?: boolean;
}

export const ItemHeading = (props: ItemHeadingProps) => {
  const headingText = props.displayName ?? props.id;
  if (headingText === undefined) return null;

  return (
    <Flex justify="space-between">
      <span className={classes.heading}>{headingText}</span>
      {props.copyNameEvent && (
        <div className={classes.copyButtons}>
          <CopyButton
            name={props.name}
            data={headingText}
            googleEvent={props.copyNameEvent}
          />

          {props.url && (
            <CopyButton
              name="URL"
              data={props.url}
              IconComponent={Upload}
              googleEvent={props.copyURLEvent}
            />
          )}
        </div>
      )}
    </Flex>
  );
};
